import { useState } from 'react';
import { useIsRecording } from '../tracks/useRecorder.js';
import { useShareState } from './useShare.js';
import { ShareSheet } from './ShareSheet.js';
import { msg } from '../../lib/messages.js';
import './share.css';

/**
 * "DELER" chip on the map while a share is live (spec 15) — sharing must
 * never be ambient/invisible. Tapping it reopens the share sheet (link + time
 * left + "Stopp deling"), same as the top-bar Share button.
 */
export function ShareChip(): JSX.Element | null {
  const { active } = useShareState();
  const recording = useIsRecording(); // stack below LOGGER instead of overlapping it
  const [open, setOpen] = useState(false);

  if (!active) return null;

  return (
    <>
      <button
        type="button"
        className={`share-chip${recording ? ' share-chip--stacked' : ''}`}
        onClick={() => setOpen(true)}
        aria-label={msg.share.title}
      >
        <span className="share-chip__dot" />
        {msg.share.chip}
      </button>
      {open && <ShareSheet onClose={() => setOpen(false)} />}
    </>
  );
}
